const darkTheme = {
  corPrincipal: "#fff",
  corSecundaria: "#eee",
  corDeFundo: "#282a35",
  corDeFundoBotao: "#fff",
  corDaBorda: "#c1c1c1",
};

export default darkTheme;
